document.addEventListener("DOMContentLoaded", function () {
  const WISHLIST_KEY = 'my_shopify_wishlist';
  const WISHLIST_ITEMS_KEY = 'my_shopify_wishlist_items';
  const WISHLIST_PAGE_URL = '/pages/wishlist';

  // ---------- Helpers ----------
  function safeJSONParse(v) {
    try { return JSON.parse(v); } catch (e) { return null; }
  }
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list || [])); } catch (e) {}
  }
  function getWishlistItems() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_ITEMS_KEY)) || []; } catch (e) { return []; }
  }
  function saveWishlistItems(items) {
    try {
      const map = new Map();
      (items || []).forEach(it => {
        if (!it) return;
        const id = it.id != null ? String(it.id) : null;
        if (id) map.set(id, it);
      });
      localStorage.setItem(WISHLIST_ITEMS_KEY, JSON.stringify(Array.from(map.values())));
    } catch (e) {}
  }
  function parsePriceToCents(v) {
    if (v == null) return 0;
    if (typeof v === 'number') return Number.isInteger(v) ? v : Math.round(v * 100);
    let s = String(v).trim().replace(/[, ]+/g, '').replace(/[^\d.-]/g, '');
    if (!s) return 0;
    const num = parseFloat(s);
    if (isNaN(num)) return 0;
    if (s.indexOf('.') !== -1) return Math.round(num * 100);
    if (num >= 1000) return Math.round(num);
    return Math.round(num * 100);
  }

  // ---------- NEW: get current variant id at click-time ----------
  // This tries multiple common locations:
  // 1) hidden input name="id" (Shopify default)
  // 2) select[name="id"] or radio input name="id"
  // 3) active swatch with data-variant-id
  function getCurrentVariantId(contextEl) {
    // prefer scoped to the product card / PDP if contextEl supplied
    const ctx = contextEl && contextEl instanceof HTMLElement ? contextEl : document;

    // 1) hidden input (most themes update this on variant change)
    const idInput = ctx.querySelector('input[name="id"]');
    if (idInput && idInput.value) return String(idInput.value);

    // 2) select[name="id"]
    const select = ctx.querySelector('select[name="id"]');
    if (select && select.value) return String(select.value);

    // 3) radio buttons name="id"
    const radioChecked = ctx.querySelector('input[type="radio"][name="id"]:checked');
    if (radioChecked) return String(radioChecked.value);

    // 4) active swatch within the context (common patterns)
    const activeSwatch = ctx.querySelector('.swatch-element.active, .swatch-option.active, .swatch .active, .color-circle.active, .swatch .active');
    if (activeSwatch) {
      const vid = activeSwatch.dataset.variantId || activeSwatch.getAttribute('data-variant-id');
      if (vid) return String(vid);
    }

    // 5) fallback: any global hidden input outside the context
    const globalIdInput = document.querySelector('input[name="id"]');
    if (globalIdInput && globalIdInput.value) return String(globalIdInput.value);

    // 6) last resort: read from add button dataset if present
    if (ctx.querySelector) {
      const btn = ctx.querySelector('.add-to-cart, .add-to-cart1');
      if (btn) {
        const ds = btn.dataset.variantId || btn.getAttribute('data-variant-id');
        if (ds) return String(ds);
      }
    }

    return null;
  }
  // ---------------------------------------------------------------

  // ---------- Wishlist UI ----------
  function updateWishlistUI(btn, inWishlist) {
    if (!btn) return;
    btn.setAttribute('aria-pressed', inWishlist ? 'true' : 'false');
    btn.classList.toggle('active', !!inWishlist);
    const svgPath = btn.querySelector('svg path');
    const svg = btn.querySelector('svg');
    if (inWishlist) {
      btn.style.borderColor = '#F44322';
      btn.setAttribute('title', 'Remove from wishlist');
      if (svgPath) { svgPath.setAttribute('fill', '#F44322'); svgPath.setAttribute('stroke', '#F44322'); }
      else if (svg) { svg.style.fill = '#F44322'; svg.style.stroke = '#F44322'; }
    } else {
      btn.style.borderColor = '';
      btn.setAttribute('title', 'Add to wishlist');
      if (svgPath) { svgPath.setAttribute('fill', 'none'); svgPath.setAttribute('stroke', 'rgba(255,138,101,0.6)'); }
      else if (svg) { svg.style.fill = 'none'; svg.style.stroke = 'rgba(255,138,101,0.6)'; }
    }
  }

  function updateAllWishlistButtons(productId, inWishlist) {
    const normalizedId = String(productId);
    try {
      const selector = `button.wishlist-btn[data-product-id="${CSS.escape(normalizedId)}"]`;
      document.querySelectorAll(selector).forEach(btn => updateWishlistUI(btn, inWishlist));
    } catch (e) {
      // fallback if CSS.escape is not available
      document.querySelectorAll('button.wishlist-btn').forEach(btn => {
        if ((btn.dataset.productId || btn.getAttribute('data-product-id')) == normalizedId) updateWishlistUI(btn, inWishlist);
      });
    }
    window.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { productId: normalizedId, inWishlist } }));
  }

  function findCardRoot(el) {
    const candidates = ['.slide.card', '.card.card--product', '.product-card', '.card', '.product-single', '.card-information'];
    let node = el;
    for (let i = 0; i < 10 && node; i++) {
      for (const sel of candidates) {
        if (node.closest) {
          const found = node.closest(sel);
          if (found) return found;
        }
      }
      node = node.parentElement;
    }
    return null;
  }

  function getTextFromSelectors(root, selectors) {
    for (const sel of selectors) {
      try {
        const el = root.querySelector(sel);
        if (el && el.textContent && el.textContent.trim()) return el.textContent.trim();
      } catch (e) {}
    }
    return null;
  }

  function getImageFromSelectors(root, selectors) {
    for (const sel of selectors) {
      try {
        const img = root.querySelector(sel);
        if (img && (img.currentSrc || img.src)) return img.currentSrc || img.src;
      } catch (e) {}
    }
    return null;
  }

  // ---------- Variant -> Product utilities ----------
  function getProductIdFromVariant(variantId) {
    if (!variantId) return null;
    const vid = String(variantId);
    const scripts = Array.from(document.querySelectorAll('script[type="application/json"], script[type="application/liquid"], script')).filter(s => s.textContent && s.textContent.trim().length > 0);
    for (const s of scripts) {
      try {
        const txt = s.textContent.trim();
        const parsed = safeJSONParse(txt);
        if (!parsed) continue;
        if (Array.isArray(parsed)) {
          const foundVariant = parsed.find(v => String(v.id) === vid || String(v.variant_id || v.variantId) === vid);
          if (foundVariant && (foundVariant.product_id || foundVariant.productId || foundVariant.productId === 0)) {
            return String(foundVariant.product_id || foundVariant.productId);
          }
        } else if (parsed && typeof parsed === 'object') {
          if (Array.isArray(parsed.variants)) {
            const v = parsed.variants.find(x => String(x.id) === vid || String(x.variant_id || x.variantId) === vid);
            if (v) {
              if (parsed.id) return String(parsed.id);
              if (v.product_id) return String(v.product_id);
            }
          }
          if (parsed.product && parsed.product.variants) {
            const v2 = parsed.product.variants.find(x => String(x.id) === vid || String(x.variant_id || x.variantId) === vid);
            if (v2) {
              if (parsed.product.id) return String(parsed.product.id);
            }
          }
        }
      } catch (e) {}
    }

    const idScripts = Array.from(document.querySelectorAll('script[id^="product-"]'));
    for (const s of idScripts) {
      const match = s.id.match(/^product-(\d+)$/);
      if (match) {
        if (s.textContent && s.textContent.indexOf(vid) !== -1) return match[1];
      }
    }
    return null;
  }

  // ---------- Wishlist Product Object ----------
  function buildProductObjectFromButton(btn) {
    if (!btn) return null;
    let rawId = btn.dataset.productId || btn.getAttribute('data-product-id') || null;
    const variantId = btn.dataset.variantId || btn.dataset.defaultVariant || btn.getAttribute('data-variant-id') || null;

    const title = btn.dataset.productTitle || btn.dataset.title || null;
    const handle = btn.dataset.productHandle || btn.dataset.handle || null;
    const image = btn.dataset.productImage || btn.dataset.image || null;
    const priceRaw = btn.dataset.productPrice || btn.dataset.price || null;
    const comparePriceRaw = btn.dataset.productComparePrice || btn.dataset.comparePrice || null;

    const card = findCardRoot(btn) || document.body;
    const finalTitle = title || getTextFromSelectors(card, ['.product__title', '.card__heading', '.card-title', 'h2', '.product-title', '.title']);
    const finalImage = image || getImageFromSelectors(card, ['img.primary-image', '.card-image img', 'img.product-featured-image', 'img']);
    const finalPriceText = priceRaw || getTextFromSelectors(card, ['.price', '.product-price', '.price-item--regular', '.price-item--sale', '.card__price']);

    if (!rawId && variantId) {
      const pidFromVariant = getProductIdFromVariant(variantId);
      if (pidFromVariant) rawId = pidFromVariant;
    }

    if (!rawId) {
      const possibleScript = card.querySelector('script[id^="product-"], script[type="application/json"]');
      if (possibleScript && possibleScript.id) {
        const m = possibleScript.id.match(/product-(\d+)/);
        if (m) rawId = m[1];
      }
    }

    const id = rawId ? String(rawId) : null;

    const priceCents = parsePriceToCents(priceRaw || finalPriceText || 0);
    const compareCents = parsePriceToCents(comparePriceRaw || 0);
    const colorName = getVariantColor(variantId);

    if (id && btn.setAttribute) {
      try { btn.setAttribute('data-product-id', id); btn.dataset.productId = id; } catch (e) {}
    }

    return {
      id,
      handle: handle || null,
      title: finalTitle || null,
      image: finalImage || null,
      price: priceCents,
      compare_at_price: compareCents,
      first_variant_id: variantId || null,
      variantId: variantId || null,
      color: colorName || null,
      addedAt: new Date().toISOString()
    };
  }

  // ---------- Wishlist Buttons ----------
  function initWishlistButtons() {
    const list = (getWishlist() || []).map(String);

    document.querySelectorAll('button.wishlist-btn').forEach(btn => {
      const productObj = buildProductObjectFromButton(btn);
      const productId = productObj && productObj.id ? String(productObj.id) : (btn.dataset.productId || btn.getAttribute('data-product-id') || null);

      if (!productId) {
        btn.setAttribute('aria-pressed', 'false');
        return;
      }

      updateWishlistUI(btn, list.includes(String(productId)));

      if (btn._wishlistBound) return;
      btn._wishlistBound = true;

      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        const pid = String(this.dataset.productId || this.getAttribute('data-product-id') || productId);
        if (!pid) return;

        let wl = (getWishlist() || []).map(String);
        let items = getWishlistItems();
        const already = wl.includes(pid);

        if (already) {
          wl = wl.filter(id => id !== pid);
          items = items.filter(it => String(it.id) !== pid);
          saveWishlist(wl);
          saveWishlistItems(items);
          updateAllWishlistButtons(pid, false);
          this.setAttribute('aria-pressed', 'false');
          this.classList.remove('active');
        } else {
          const productObjNow = buildProductObjectFromButton(this) || { id: pid, addedAt: new Date().toISOString() };
          wl.push(pid);
          wl = Array.from(new Set(wl.map(String)));
          const map = new Map(items.map(it => [String(it.id), it]));
          map.set(pid, productObjNow);
          const newItems = Array.from(map.values());
          saveWishlist(wl);
          saveWishlistItems(newItems);
          updateAllWishlistButtons(pid, true);
          this.setAttribute('aria-pressed', 'true');
          this.classList.add('active');
          if (this.getAttribute('data-redirect') === 'true') {
            window.location.href = WISHLIST_PAGE_URL;
            return;
          }
          this.classList.add('pulsed');
          setTimeout(() => this.classList.remove('pulsed'), 420);
        }
      });
    });
  }
  // 🔥 FORCE SYNC WISHLIST STATE ON EVERY PAGE LOAD
(function syncWishlistStorage() {
  try {
    const ITEMS_KEY = 'my_shopify_wishlist_items';
    const ID_KEY = 'my_shopify_wishlist';

    const items = JSON.parse(localStorage.getItem(ITEMS_KEY)) || [];
    const ids = items.map(it => String(it.id));

    localStorage.setItem(ID_KEY, JSON.stringify(ids));
  } catch (e) {
    console.warn('Wishlist sync failed', e);
  }
})();


  // ---------- Color Swatches ----------
  function initColorSwatches() {
    document.querySelectorAll('.slide.card, .card.card--product, .card-information').forEach(cardRoot => {
      const swatches = cardRoot.querySelectorAll('.color-circle[data-variant-id]');
      if (!swatches.length) return;
      const addToCartBtn = cardRoot.querySelector('button.add-to-cart');
      const imageEl = cardRoot.querySelector('.primary-image, .card-image img');
      const defaultImage = imageEl ? imageEl.src : '';

      swatches.forEach(s => {
        if (s._colorBound) return;
        s._colorBound = true;
        s.addEventListener('click', function (ev) {
          ev.preventDefault();
          swatches.forEach(x => x.classList.remove('active'));
          this.classList.add('active');
          if (addToCartBtn) addToCartBtn.dataset.variantId = this.dataset.variantId;
          if (imageEl && this.dataset.variantImage) imageEl.src = this.dataset.variantImage;
        });
      });

      const first = swatches[0];
      if (first && addToCartBtn) addToCartBtn.dataset.variantId = first.dataset.variantId;
    });
  }

  // ---------- Slider arrows ----------
  document.querySelectorAll('.custom-slider').forEach(slider => {
    const wrapper = slider.querySelector('.slider-wrapper');
    const btnLeft = slider.querySelector('.slider-arrow.left');
    const btnRight = slider.querySelector('.slider-arrow.right');
    if (!wrapper || !btnLeft || !btnRight) return;
    const scrollAmount = 300;
    function updateArrows() {
      btnLeft.disabled = wrapper.scrollLeft <= 0;
      btnRight.disabled = wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth - 1;
    }
    updateArrows();
    btnLeft.addEventListener('click', () => wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' }));
    btnRight.addEventListener('click', () => wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' }));
    wrapper.addEventListener('scroll', updateArrows);
  });

  // ---------- AirReviews ----------
  function initAirReviews() {
    if (window.AirReviews && typeof AirReviews.init === "function") {
      AirReviews.init();
    }
  }

  // ---------- Init ----------
  initWishlistButtons();
  initColorSwatches();
  // initAddToCartButtons();
  initAirReviews();

  // window.initAddToCartButtons = initAddToCartButtons;
  window.initWishlistButtons = initWishlistButtons;
});

// ---------- Variant Color Helper ----------
function getVariantColor(variantId) {
  const scripts = document.querySelectorAll('script[type="application/json"][id^="product-"]');
  for (const s of scripts) {
    try {
      const variants = JSON.parse(s.textContent);
      if (Array.isArray(variants)) {
        const variant = variants.find(v => String(v.id) === String(variantId) || String(v.variant_id) === String(variantId));
        if (variant) return variant.option1 || variant.title || null;
      } else if (variants && variants.variants) {
        const variant = variants.variants.find(v => String(v.id) === String(variantId) || String(v.variant_id) === String(variantId));
        if (variant) return variant.option1 || variant.title || null;
      }
    } catch (e) {}
  }
  return null;
}


// ---------- 🧩 Dynamic Reinit for Product Grid / AJAX Content ----------
document.addEventListener('shopify:section:load', () => {
  if (window.initWishlistButtons) window.initWishlistButtons();
  // if (window.initAddToCartButtons) window.initAddToCartButtons();
  if (typeof initColorSwatches === 'function') initColorSwatches();
  if (typeof initAirReviews === 'function') initAirReviews();
});

const observer = new MutationObserver((mutations) => {
  let shouldReinit = false;
  for (const mutation of mutations) {
    mutation.addedNodes.forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      if (
        node.matches && (
          node.matches('.card, .slide.card, .product-grid, .card-information') ||
          node.querySelector && (node.querySelector('.wishlist-btn') || node.querySelector('.add-to-cart'))
        )
      ) {
        shouldReinit = true;
      }
    });
  }
  if (shouldReinit) {
    if (window.initWishlistButtons) window.initWishlistButtons();
    // if (window.initAddToCartButtons) window.initAddToCartButtons();
    if (typeof initColorSwatches === 'function') initColorSwatches();
    if (typeof initAirReviews === 'function') initAirReviews();
  }
});
observer.observe(document.body, { childList: true, subtree: true });
